export default __webpack_public_path__ + "static/media/Figma.cbb1d520.png";